//Components
import LeftContainer from "../../components/molecules/LeftContainer";
import RightContainer from "../../components/molecules/RightContainer";
//Styles
import "../../globalStyles/shared.scss";
import "./styles.scss";

function Home() {
  return (
    <div className="base-page">
      <div className="home__main-container">
        <LeftContainer />
        <RightContainer />
      </div>
    </div>
  );
}

export default Home;
